<template>
  <feather-icon icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click="getBookLists()"/>
</template>

<script>
  import 'jspdf-autotable'
  import jsPDF from "jspdf";
  import {font} from "./assets/THSarabunNew-normal";
  import {font_bold} from "./assets/THSarabunNew-bold";
  import moment from "moment";
  import moduleBookList from "@/store/booklist/moduleBookList.js";
  import {formatNumber2Digit, formatNumber} from "./assets/utils";

  export default {
    props: ['billConfig', 'area', 'org', 'status'],
    components: {
      jsPDF,
    },
    name: "P17PrapaReport",
    data() {
      return {
        thmonth: ['', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม',
          'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน',
          'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      }
    },
    methods: {
      currentThaiDate() {
        const date = moment().format('DD/MM/YYYY');
        const dateSplit = date.split('/');
        const year = parseInt(dateSplit[2]) + 543;
        return dateSplit[0] + '/' + dateSplit[1] + '/' + year;
      },
      warningDialog() {
        this.$vs.dialog({
          type: 'alert',
          color: 'warning',
          title: `คำเตือน`,
          text: 'ไม่มีรายชื่อในรายงาน ป.17 ค่าน้ำ',
          acceptText: 'ปิด'
        })
      },
      async getBookLists() {
        this.$vs.loading();
        let payload = {};
        payload.B01 = this.billConfig.value;
        if (this.area.value !== 'all') {
          payload.M02 = this.area.value;
        }
        if (this.status !== undefined) {
          payload.B10 = this.status;
        }
        await this.$store.dispatch("bookLists/fetchDebtDataListItems", payload).then((res) => {
          if (res.status === 200 && res.data.length !== 0) {
            const booklists = res.data;
            this.generatePDF(booklists);
            this.$vs.loading.close();
          } else {
            this.warningDialog();
            this.$vs.loading.close();
          }
        }).catch((error) => {
          this.warningDialog();
          this.$vs.loading.close();
        });
      },
      generatePDF(bookLists) {
        const doc = new jsPDF({format: [210, 330], unit: 'mm', orientation: 'landscape',});
        const org = this.org;
        const district = org.Org01;
        const address = org.Org03;
        const month = bookLists[0].CB04;
        const id_bill = bookLists[0].B01;
        const area = this.area;
        const date = this.currentThaiDate()
        let sumUnit = 0;
        let sumPrapa = 0;
        let sumService = 0;
        let sumVat = 0;
        let sum = 0;
        let array = [];
        let sum_payment_footer = 0;
        for (let i = 0; i < bookLists.length; i++) {
          const data = bookLists[i];
          let BA11 = 0;
          let BA12 = 0;
          let BA13 = 0;
          let sumBA = 0;
          if (data.BA11 !== undefined && data.BA11 !== null && data.BA11 !== '' && data.BA11 !== 'NaN') {
            BA11 = parseFloat(data.BA11);
            sumPrapa += parseFloat(data.BA11);
          }
          if (data.BA12 !== undefined && data.BA12 !== null && data.BA12 !== '' && data.BA12 !== 'NaN') {
            BA12 = parseFloat(data.BA12);
            sumService += parseFloat(data.BA12);
          }
          if (data.BA13 !== undefined && data.BA13 !== null && data.BA13 !== '' && data.BA13 !== 'NaN') {
            BA13 = parseFloat(data.BA13);
            sumVat += parseFloat(data.BA13);
          }
          if (data.B21 !== undefined && data.B21 !== null && data.B21 !== '' && data.B21 !== 'NaN') {
            sumUnit += parseInt(data.B21);
          }
          sumBA = BA11 + BA12 + BA13;
          sum += sumBA;


          let formatDate = '';
          let status_bill = '';
          let sum_payment = 0;
          if(data.B24!==null && data.B24 !==undefined){
            let dateNow = moment(data.B24).format('DD/MM/YYYY');
            let day;
            let month;
            let yearth;
            if (dateNow === 'Invalid date') {
              let dateArr = data.B24.split(' ');
              let dateArr0 = dateArr[0].split('/');
              yearth = parseInt(dateArr0[2]) + 543;
              day = parseInt(dateArr0[0]);
              month = this.thmonth[parseInt(dateArr0[1])];
            } else {
              let dateArr0 = dateNow.split('/');
              yearth = parseInt(dateArr0[2]) + 543;
              day = parseInt(dateArr0[0])
              month = this.thmonth[parseInt(dateArr0[1])];
            }
            status_bill = 'ค้างจ่าย';
            if (data.B10 === '1') {
              status_bill = 'จ่ายแล้ว';
              sum_payment = sumBA;
              formatDate = day + ' ' + month + ' ' + yearth;
            }
          }
          sum_payment_footer += sum_payment;
          let B02 = ''
          if (data.B02 !== '')
            B02 = data.B02
          array.push([
            i + 1,
            data.B03,
            data.member_name,
            B02,
            status_bill,
            data.member_rate,
            data.B18,
            data.B20,
            data.B21,
            formatNumber2Digit(BA11),
            formatNumber2Digit(BA12),
            formatNumber2Digit(BA13),
            formatNumber(sumBA),
            formatDate,
            formatNumber(sum_payment)
          ]);
        }
        array.push([
          'ผลรวมของ',
          {content: area.label, colSpan: 7},
          sumUnit,
          formatNumber(sumPrapa),
          formatNumber(sumService),
          formatNumber(sumVat),
          formatNumber(sum),
          ' ',
          formatNumber(sum_payment_footer)
        ]);
        var totalPagesExp = '{total_pages_count_string}';
        doc.addFileToVFS('THSarabunNew-normal.ttf', font);
        doc.addFileToVFS('THSarabunNew-bold.ttf', font_bold);
        doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
        doc.addFont('THSarabunNew-bold.ttf', 'THSarabunNew', 'bold');
        doc.autoTable({
          showHead: 'everyPage',
          showFoot: 'everyPage',
          styles: {font: 'THSarabunNew', fontSize: 11, textColor: 0},
          margin: {left: 5, top: 35, right: 5},
          headStyles: {fillColor: [255, 255, 255], textColor: 0, lineColor: 180, lineWidth: 0.1},
          columnStyles: {
            0: {halign: 'right'},
            4: {halign: 'center'},
            5: {halign: 'center'},
            6: {halign: 'center'},
            7: {halign: 'center'},
            8: {halign: 'right'},
            9: {halign: 'right'},
            10: {halign: 'right'},
            11: {halign: 'right'},
            13: {halign: 'right'},
            14: {halign: 'right'}
          },
          theme: 'grid',
          head: [
            [
              {content: area.label, colSpan: 6},
              {content: 'เลขอ่านของมาตรวัดน้ำ', colSpan: 3, styles: {halign: 'center'}},
              {content: 'หนี้สินที่เกิดขึ้นในเดือนนี้', colSpan: 5, styles: {halign: 'center'}},
              {content: 'การชำระหนี้', styles: {halign: 'center'}}
            ],
            [
              'ลำดับที่',
              'รหัส',
              'ชื่อสกุลสมาชิกที่ใช้น้ำ',
              'เลขที่ใบเสร็จ',
              'สถานะบิลรอบที่จ่าย',
              'สูตรค่าน้ำ',
              'จดครั้งแรก',
              'จดครั้งหลัง',
              'จำนวนหน่วย',
              'ค่าน้ำ',
              'ค่าบริการ',
              'ภาษี',
              'รวมเงิน',
              'วันที่ชำระ',
              'จำนวนเงินที่ชำระ'
            ]
          ],
          body: array,
          didDrawPage: function (data) {
            // Header
            doc.setFont('THSarabunNew', 'bold');
            doc.setFontSize(16);
            doc.text(district, doc.internal.pageSize.getWidth() / 2, 10, {align: 'center'});
            doc.text(address, doc.internal.pageSize.getWidth() / 2, 16, {align: 'center'});
            doc.setFontSize(14);
            doc.text('บัญชีรายตัวลูกหนี้ ประเภทใช้มาตรวัดน้ำ', doc.internal.pageSize.getWidth() / 2, 25, {align: 'center'});
            doc.text('ประจำเดือน ' + month + ' (' + id_bill + ')', doc.internal.pageSize.getWidth() / 2, 30, {align: 'center'});
            doc.setFont('THSarabunNew', 'normal');
            //footer
            var str = 'Page ' + doc.internal.getNumberOfPages();
            if (typeof doc.putTotalPages === 'function') {
              str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(12);
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text('วันที่พิมพ์ ' + date, 8, pageHeight - 8,);
            // doc.text('หน้าที่พิมพ์ ' + str, 288, pageHeight - 8, {align: 'right'});
          },
        });
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp);
        }
        doc.save(`ป.17ค่าน้ำ-` + moment().format('DD-MM-YYYY') + '.pdf');
      }
    },
    created() {
      if (!moduleBookList.isRegistered) {
        this.$store.registerModule('bookLists', moduleBookList);
        moduleBookList.isRegistered = true;
      }
    }
  }
</script>
